// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sortable:hover {
  background-color: #f5f5f5;
}

.sortable.active {
  background-color: #e3f2fd;
}

.sortable mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.badge {
  font-size: 0.85em;
  padding: 5px 10px;
}

.badge-primary {
  background-color: #007bff;
}

.badge-info {
  background-color: #17a2b8;
}

.badge-secondary {
  background-color: #6c757d;
}

table tbody tr:hover {
  background-color: #f8f9fa;
}
`, "",{"version":3,"sources":["webpack://./src/app/ai-test-list/ai-test-list.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.sortable:hover {\n  background-color: #f5f5f5;\n}\n\n.sortable.active {\n  background-color: #e3f2fd;\n}\n\n.sortable mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n}\n\n.badge {\n  font-size: 0.85em;\n  padding: 5px 10px;\n}\n\n.badge-primary {\n  background-color: #007bff;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n}\n\ntable tbody tr:hover {\n  background-color: #f8f9fa;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
